import { richText } from '../../utils/html';

export default ({ primary }) => {
  return {
    textContent: richText(primary.legal_mentions_content),
  };
};
